import { useEffect, useMemo, useRef } from "react";
import { MapContainer, TileLayer, Marker, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix Leaflet's default icon paths (Webpack/CRA strips the URLs otherwise)
const goldPin = L.divIcon({
    className: "gpm-map-pin",
    html: '<div style="width:28px;height:36px;position:relative;transform:translate(-14px,-32px);"><svg viewBox="0 0 28 36" width="28" height="36" xmlns="http://www.w3.org/2000/svg"><path d="M14 0C6.3 0 0 6.3 0 14c0 10 14 22 14 22s14-12 14-22C28 6.3 21.7 0 14 0z" fill="#DAA520" stroke="#002657" stroke-width="1.5"/><circle cx="14" cy="14" r="5" fill="#002657"/></svg></div>',
    iconSize: [28, 36],
    iconAnchor: [14, 32],
});

function ClickCapture({ onPick }) {
    useMapEvents({
        click(e) {
            onPick(e.latlng.lat, e.latlng.lng);
        },
    });
    return null;
}

function Recenter({ lat, lng }) {
    const map = useMap();
    useEffect(() => {
        if (typeof lat === "number" && typeof lng === "number") {
            map.setView([lat, lng], map.getZoom() < 14 ? 15 : map.getZoom(), { animate: true });
        }
    }, [lat, lng, map]);
    return null;
}

export default function LocationMapPicker({ lat, lng, onChange, height = 288 }) {
    const markerRef = useRef(null);
    // Default: Nagpur city center
    const center = useMemo(
        () => (typeof lat === "number" && typeof lng === "number" ? [lat, lng] : [21.1458, 79.0882]),
        [lat, lng]
    );

    const dragHandlers = useMemo(
        () => ({
            dragend() {
                const m = markerRef.current;
                if (m) {
                    const p = m.getLatLng();
                    onChange(p.lat, p.lng);
                }
            },
        }),
        [onChange]
    );

    return (
        <div className="rounded-md overflow-hidden border border-navy-500/10" style={{ height }} data-testid="location-map-picker">
            <MapContainer
                center={center}
                zoom={typeof lat === "number" ? 15 : 12}
                style={{ height: "100%", width: "100%" }}
                scrollWheelZoom={true}
            >
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <ClickCapture onPick={onChange} />
                {typeof lat === "number" && typeof lng === "number" && (
                    <>
                        <Recenter lat={lat} lng={lng} />
                        <Marker
                            position={[lat, lng]}
                            icon={goldPin}
                            draggable={true}
                            eventHandlers={dragHandlers}
                            ref={markerRef}
                        />
                    </>
                )}
            </MapContainer>
        </div>
    );
}
